import React, { useState } from "react";
import axios from "axios";
import "./Maintenance.css";

axios.defaults.withCredentials = true;

const TitilMaintenance = () => {
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [alertPopup, setAlertPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
  });

  const openAlertPopup = (type, title, message) => {
    setAlertPopup({
      show: true,
      type,
      title,
      message,
    });
  };

  const closeAlertPopup = () => {
    setAlertPopup({
      show: false,
      type: "",
      title: "",
      message: "",
    });
  };

  const closeFormPopup = () => {
    if (submitting) return;

    setShowFormPopup(false);
    setFormData({
      name: "",
      address: "",
      phone: "",
      email: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);

      await axios.post(
        "/maintenance/request",
        formData,
        {
          withCredentials: true,
        }
      );

      setFormData({
        name: "",
        address: "",
        phone: "",
        email: "",
      });

      setShowFormPopup(false);

      openAlertPopup(
        "success",
        "Submit Success",
        "ส่งคำขอเรียบร้อยแล้ว เจ้าหน้าที่ฝ่ายขายจะติดต่อกลับโดยเร็วที่สุด"
      );
    } catch (err) {
      console.error("maintenance request error:", err);

      openAlertPopup(
        "error",
        "Submit Failed",
        err.response?.data?.error ||
          err.message ||
          "ไม่สามารถส่งคำขอได้ กรุณาลองใหม่อีกครั้ง"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="hardware-container">
        <div className="content">
          <h2 className="heading"><span>Maintenance Services</span></h2>

          <p className="description">
            Prosccope provides comprehensive IT maintenance services to ensure
            your systems run reliably, securely, and with minimal downtime. Our
            services are designed to support critical IT infrastructure,
            endpoint devices, and core applications in a way that minimizes risk
            and maximizes performance.
            <br />
            <br />
            We offer both Troubleshooting and proactive maintenance, including
            system monitoring, updates, troubleshooting, and hardware health
            checks. Whether you need on-site support, remote assistance, or
            SLA-based service contracts — we tailor packages to suit your needs.
            <br />
            <br />
            We also provide hardware spare parts and device replacements as part
            of our service options — minimizing downtime and enabling seamless
            system recovery when needed.
            <br />
            <br />
            Choose from flexible support levels — from basic remote assistance
            to fully managed SLA-based service with onsite support, reporting,
            and dedicated account handling.
            <br />
            <br />
            Let us take care of your IT backbone, so you can focus on growth,
            innovation, and delivering value to your customers.
          </p>
        </div>

        <div className="maintenance-container">
          <div className="content">
            <h2 className="service-heading">
              Support Center - Maintenance Services
            </h2>

            <table className="service-table">
              <thead>
                <tr>
                  <th>Service Features</th>
                  <th>Basic Support</th>
                  <th>Standard Support</th>
                  <th>Premium SLA</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Business Hour Support (Mon-Fri)</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>On-site Support</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Remote Troubleshooting</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Proactive System Monitoring</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Scheduled Health Checks</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Patch Management & Auto Updates</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Performance Reporting</td>
                  <td className="support-no">✘</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>SLA Response Time</td>
                  <td className="support-no2">N/A</td>
                  <td className="support-no2">8 hrs</td>
                  <td className="support-no2">4 hrs</td>
                </tr>

                <tr>
                  <td>Hardware Spare Part Provisioning</td>
                  <td className="support-no">✘</td>
                  <td className="support-no2">Optional</td>
                  <td className="support-yes">✓</td>
                </tr>

                <tr>
                  <td>Dedicated Account Manager</td>
                  <td className="support-no">✘</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                </tr>
              </tbody>
            </table>

            <p className="addons-info">
              Optional add-ons available: Backup appliances, disaster recovery
              simulation, and extended warranty support.
            </p>
          </div>
              
          <div className="ma-request-section">
            <button
              type="button"
              className="ma-request-btn"
              onClick={() => setShowFormPopup(true)}
            >
              Request Maintenance Service
            </button>
          </div>
        </div>
      </div>

      {showFormPopup && (
        <div className="ma-popup-overlay">
          <div className="ma-popup-card">
            <div className="ma-popup-header">
              <h3>New MA Customer Request</h3>

              <button
                type="button"
                className="ma-popup-close"
                onClick={closeFormPopup}
                disabled={submitting}
              >
                ×
              </button>
            </div>

            <form className="ma-request-form-popup" onSubmit={handleSubmit}>
              <div className="ma-form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div className="ma-form-group">
                <label>Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Enter your address"
                  required
                />
              </div>

              <div className="ma-form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <div className="ma-form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="ma-form-actions">
                <button
                  type="submit"
                  className="ma-submit-btn"
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Submit Request"}
                </button>

                <button
                  type="button"
                  className="ma-cancel-btn"
                  onClick={closeFormPopup}
                  disabled={submitting}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {alertPopup.show && (
        <div className="ma-popup-overlay">
          <div className="ma-alert-popup-card">
            <div
              className={
                alertPopup.type === "success"
                  ? "ma-alert-icon success"
                  : "ma-alert-icon error"
              }
            >
              {alertPopup.type === "success" ? "✓" : "!"}
            </div>

            <h3>{alertPopup.title}</h3>
            <p>{alertPopup.message}</p>

            <button
              type="button"
              className={
                alertPopup.type === "success"
                  ? "ma-alert-ok-btn success"
                  : "ma-alert-ok-btn error"
              }
              onClick={closeAlertPopup}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TitilMaintenance;